import AuthComponent from "@components/auth/component";
import BackButton from "@components/buttons/BackButton";
import CustomButton from "@components/buttons/CustomButton";
import CustomFileField from "@components/form/CustomFileField";
import { LoadingSpinner } from "@components/layouts/LoadingSpinner";
import PageWrapper from "@components/layouts/PageWrapper";
import { Toast } from "@helpers/popups/Toast";
import {
  sliderSchema,
  ZSlider,
} from "@helpers/validation-schemas/cms/slider.schema";
import { zodResolver } from "@hookform/resolvers/zod";
import { useErrorHandling } from "@hooks/useErrorHandling";
import { useCreateSliderMutation } from "@states/cms/slider.api";
import { TFailResponse } from "@type-defs/general/TFailResponse";
import { SLIDER_MANAGEMENT } from "@utils/constants/slider-management/slider-management.constants";
import { castTypeArr } from "@utils/general/cast-type";
import React, { useEffect } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

function SliderCreatePage() {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    setError,
    watch,
    control,
    formState: { errors, isSubmitting }, //TODO: need to handle wrong field name errors, cause they are uncaught
    reset,
    setValue,
  } = useForm<any>({
    // resolver: zodResolver(sliderSchema),
  });
  const [createSlider, { data, isSuccess, isLoading, error: createError }] =
    useCreateSliderMutation();
  useErrorHandling(...castTypeArr<TFailResponse>([createError]));

  useEffect(() => {
    if (isSuccess && data) {
      Toast.fire({
        title: data.message,
        icon: "success",
      });

      navigate(SLIDER_MANAGEMENT.BASE_PATH, {
        state: {
          reload: true,
        },
      });
    }
  }, [isSuccess, data, navigate, Toast]);
  const onSubmit: SubmitHandler<any> = async (data) => {
    try {
      console.log(data);
      const formData = new FormData();

      const slider_image = data.slider_image?.[0]; // Assuming slider_image input is an array

      if (slider_image) {
        formData.append("slider_image", slider_image); // Appends the file in binary form
        await createSlider(formData);
      } else {
        Toast.fire({
          title: "Slider Image is Required",
          icon: "error",
        });
      }
    } catch (error: any) {
      setError("root", {
        message: error.message,
      });
    }
  };
  console.error(errors);
  return (
    <AuthComponent
      action="create"
      module="CMS"
      subModule="Slider Management"
      page
    >
      <PageWrapper>
        {isLoading && <LoadingSpinner />}
        <BackButton />
        <form onSubmit={handleSubmit(onSubmit)}>
          <h3 className="mb-4 ml-2 text-2xl font-[600] text-primary-dark uppercase">
            {SLIDER_MANAGEMENT.ADD_NEW_TITLE}
          </h3>
          <CustomFileField
            label="Slider Image"
            placeHolder="Slider Image here"
            errors={errors}
            name="slider_image"
            register={register}
            setValue={setValue}
            watch={watch}
          />

          <div className="ml-2 mt-14">
            <CustomButton
              isLarge
              title="Cancel"
              color="white"
              textColor="gray.800"
              className="mr-10"
              handleClick={() => navigate(-1)}
            />
            <CustomButton
              handleClick={handleSubmit(onSubmit)}
              isLarge
              title={isSubmitting ? "Loading..." : "Submit"}
              disabled={isSubmitting}
              type="submit"
            />
          </div>
          {errors.root && (
            <div className="mt-6 text-red-500">{errors.root.message}</div>
          )}
        </form>
      </PageWrapper>
    </AuthComponent>
  );
}

export default SliderCreatePage;
